module.exports = __webpack_public_path__ + "static/turkbox-3fdb9e943ffd6668e65e40138e3dfbf4.png";